import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ce2d22e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-moa-content__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_moa_frame_not_approved = _resolveComponent("moa-frame-not-approved")!
  const _component_moa_frame_intro_screen_two = _resolveComponent("moa-frame-intro-screen-two")!
  const _component_moa_frame_intro_screen_three = _resolveComponent("moa-frame-intro-screen-three")!
  const _component_moa_frame_human_organs = _resolveComponent("moa-frame-human-organs")!
  const _component_moa_frame_virus_entry = _resolveComponent("moa-frame-virus-entry")!
  const _component_moa_frame_virus_rna = _resolveComponent("moa-frame-virus-rna")!
  const _component_moa_frame_protein_detach = _resolveComponent("moa-frame-protein-detach")!
  const _component_moa_frame_purple_rna_created = _resolveComponent("moa-frame-purple-rna-created")!
  const _component_moa_frame_rna_move = _resolveComponent("moa-frame-rna-move")!
  const _component_moa_frame_rna_coiled = _resolveComponent("moa-frame-rna-coiled")!
  const _component_moa_frame_vitamin_release = _resolveComponent("moa-frame-vitamin-release")!
  const _component_moa_frame_protein_chain_break = _resolveComponent("moa-frame-protein-chain-break")!
  const _component_moa_frame_protein_chain_svg = _resolveComponent("moa-frame-protein-chain-svg")!
  const _component_moa_frame_purple_rna_created_version = _resolveComponent("moa-frame-purple-rna-created-version")!
  const _component_moa_frame_mutagenesis = _resolveComponent("moa-frame-mutagenesis")!
  const _component_moa_frame_unable_cut = _resolveComponent("moa-frame-unable-cut")!
  const _component_moa_frame_bond = _resolveComponent("moa-frame-bond")!
  const _component_moa_frame_mutagenesis_version = _resolveComponent("moa-frame-mutagenesis-version")!
  const _component_moa_frame_ritonavir = _resolveComponent("moa-frame-ritonavir")!
  const _component_moa_frame_molecules = _resolveComponent("moa-frame-molecules")!
  const _component_moa_frame_person_cup = _resolveComponent("moa-frame-person-cup")!
  const _component_moa_credits = _resolveComponent("moa-credits")!
  const _component_moa_frame_box = _resolveComponent("moa-frame-box")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hd-moa-content hd-container js-timeline-container-2", { 'is-ready': _ctx.ready }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_moa_frame_not_approved, {
        class: "hd-moa-content__content",
        ready: _ctx.ready
      }, null, 8, ["ready"]),
      _createVNode(_component_moa_frame_intro_screen_two, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_intro_screen_three, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_human_organs, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_virus_entry, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_virus_rna, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_protein_detach, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_purple_rna_created, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_rna_move, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_rna_coiled, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_vitamin_release, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_protein_chain_break, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_protein_chain_svg, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_purple_rna_created_version, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_mutagenesis, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_unable_cut, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_bond, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_mutagenesis_version, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_ritonavir, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_molecules, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_frame_person_cup, { class: "hd-moa-content__content" }),
      _createVNode(_component_moa_credits, { class: "hd-moa-content__content" })
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datum, (frame) => {
      return (_openBlock(), _createBlock(_component_moa_frame_box, {
        key: frame.endpointId,
        "endpoint-id": frame.endpointId,
        class: _normalizeClass({ 'is-no-frame-box': frame['no-frame-box'] === 'true' })
      }, null, 8, ["endpoint-id", "class"]))
    }), 128))
  ], 2))
}